import Error from "next/error"
import Head from "next/head"
import React from "react"

import Breadcrumb from "~/components/organisms/Breadcrumb"
import Footer from "~/components/organisms/Footer"
import { NewGradJobsPage } from "~/components/pages/NewGradJobsPage"
import { internalLink, staticPath } from "~/services/helper"
import RootStore from "~/stores/RootStore"
import { InfraNextPageContext } from "~/types/InfraNextPageContext"
import { ReturnGetInitialProps } from "~/types/ReturnGetInitialProps"

type GetInitialProps = ReturnGetInitialProps<typeof NewGradJobs["getInitialProps"]>

class NewGradJobs extends React.Component {
  static async getInitialProps({ initialStoreData, res }: InfraNextPageContext) {
    const { newGradJobStore, masterDataStore } = initialStoreData
    const fetchForGroupedRecruitment = newGradJobStore.fetchGroupedRecruitment()
    const fetchForPickupRecruitment = newGradJobStore.fetchPickupRecruitment()
    const fetchForMasterDataStore = masterDataStore.fetch()
    const [groupedRecruitmentList, pickupRecruitment, { majorOccupations }] = await Promise.all([
      fetchForGroupedRecruitment,
      fetchForPickupRecruitment,
      fetchForMasterDataStore,
    ])
    // NOTE: 新卒求人ページ廃止のため、暫定対応として 404 を返す
    res.statusCode = 404

    return { groupedRecruitmentList, pickupRecruitment, majorOccupations }
  }

  render() {
    // NOTE: 新卒求人ページ廃止のため、暫定対応として 404 を返す
    return <Error statusCode={404} />

    // const crumbs = [
    //   {
    //     name: "新卒求人トップ",
    //     link: internalLink(`/new-grad-jobs`),
    //   },
    // ]

    // const { groupedRecruitmentList, pickupRecruitment, majorOccupations } = this.props as GetInitialProps
    // return (
    //   <>
    //     <Head>
    //       <title>職種別就職活動・新卒採用求人情報 | Infra新卒（インフラ新卒）</title>
    //       <meta
    //         name="description"
    //         content="職種別の新卒求人情報を掲載！あなたの指向性から適切な企業を探したり、エントリーシートやグループディスカッションの対策、面接対策などをサポートする就職相談会を実施中！"
    //       />
    //       <meta property="og:title" content="職種別就職活動・新卒採用求人情報 | Infra新卒（インフラ新卒）" />
    //       <meta
    //         property="og:description"
    //         content="職種別の新卒求人情報を掲載！あなたの指向性から適切な企業を探したり、エントリーシートやグループディスカッションの対策、面接対策などをサポートする就職相談会を実施中！"
    //       />
    //       <meta property="og:image" content={`${process.env.APP_HOST + staticPath("/static/images/ogp.png")}`} />
    //     </Head>

    //     {pickupRecruitment && (
    //       <NewGradJobsPage
    //         groupedRecruitmentList={groupedRecruitmentList}
    //         pickupRecruitment={pickupRecruitment}
    //         majorOccupations={majorOccupations}
    //       />
    //     )}
    //     <Breadcrumb crumbs={crumbs} />
    //     <Footer />
    //   </>
    // )
  }
}

export default NewGradJobs
